import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@material-ui/core";
import { HistoryDatagrid } from "components/HistoryGrid/Grid";
import { AppReferenceManyField } from "components/list/AppReferenceManyField";
import React from "react";
import { useTranslate } from "react-admin";

import { palletsUseStyles } from "../../Styles";
import { PalletHistoryGrid } from "./PalletHistoryGrid";

export const PalletHistoryDialog = ({ open, onClose, pallet }) => {
	const translate = useTranslate();
	const classes = palletsUseStyles();

	if (!pallet) return null;

	return (
		<Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
			<DialogTitle>
				{translate("osfc.dialogs.pallet_history.title")} - ID: {pallet.id}
			</DialogTitle>
			<DialogContent className={classes.compactDatagrid}>
				<AppReferenceManyField
					record={{ id: pallet.id, original_id: pallet.id }}
					resource="pallets"
					reference="pallet-history"
					target="original_id"
					sort={{ field: "id", order: "DESC" }}
					filter={{ no_range: true }}
					pagination={false}
				>
					<HistoryDatagrid noWraps={true}>
						<PalletHistoryGrid />
					</HistoryDatagrid>
				</AppReferenceManyField>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="primary">
					{translate("ra.action.close")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
